import { useMemo } from 'react';
import { ACTIVE_ETH_BASED_NETWORKS, ChainId } from '@shared/utils/config/networks';
import { stableCoins } from '@/components/explore/stableCoins';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
export default function useParseAssetsIntoNativeAndCash(assetData, networkId) {
  const _networkStableCoins = _networkId => stableCoins.filter(_coin => {
    var _a;
    return (_a = _coin.networks) === null || _a === void 0 ? void 0 : _a.includes(_networkId);
  }).map(_coin => ({
    name: _coin.name,
    address: _coin.tokens[_networkId],
    network: _networkId
  }));
  const _nativeNetworkBalances = useMemo(() => {
    if (!assetData || !networkId) return [];
    return assetData.balancesByChain.find(_chain => _chain.chainId === networkId).balances.filter(_token => _token.native_token || _networkStableCoins(networkId).some(_coin => _coin.address.toLowerCase() === _token.contract_address.toLowerCase())).sort((a, b) => {
      if (a.native_token && !b.native_token) return -1;
      if (!a.native_token && b.native_token) return 1;
      return 0;
    }).map(x => {
      const networkToUse = () => {
        if (ACTIVE_ETH_BASED_NETWORKS.includes(networkId)) {
          return ChainId.ETHEREUM;
        }
        return networkId;
      };
      return Object.assign(Object.assign({}, x), {
        logo_url: getNetworkLogo(networkToUse()),
        logo_urls: {
          token_logo_url: getNetworkLogo(networkToUse()),
          chain_logo_url: getNetworkLogo(networkId)
        }
      });
    });
  }, [assetData, networkId]);
  const _otherNetworkNativeBalances = useMemo(() => {
    if (!assetData || !networkId) return [];
    return assetData.balances.filter(_token => _token.native_token).filter(a => a.usd_value > 0 && a.network !== networkId).sort((a, b) => {
      if (a.network == 1) {
        return 100;
      }
      if (b.network == 1) {
        return -100;
      }
      return b.usd_value - a.usd_value;
    });
  }, [assetData, networkId]);
  const _allCashBalances = useMemo(() => {
    if (!assetData || !networkId) return [];
    return assetData.balances.filter(_token => {
      return _networkStableCoins(_token.network).some(_coin => _coin.address.toLowerCase() === _token.contract_address.toLowerCase());
    });
  }, [assetData, networkId]);
  return {
    _networkStableCoins,
    _allCashBalances,
    _nativeNetworkBalances,
    _otherNetworkNativeBalances
  };
}